import { useEffect } from 'preact/compat'
import { loadScript, unloadScript } from '../helpers/common'

export default function useScript(
  url,
  onLoad = () => {},
  onError = () => {},
  removeOnUnmount = true
) {
  useEffect(() => {
    const script = loadScript(url, onLoad, onError)

    return () => {
      if (!removeOnUnmount) return

      unloadScript(script, onLoad, onError)
    }
  }, [url])
}
